import React from 'react';
import styled from 'styled-components';
import ProductSkeleton from '../Products/ProductSkeleton/ProductSkeleton';

const SkeletonContainer = styled.div`
  width: 100%;
  padding: 20px 0;
`;

const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 20px;
`;

const SkeletonTitle = styled.div`
  width: 200px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

const SkeletonViewAll = styled.div`
  width: 80px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  padding: 0 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

/**
 * CarouselSkeleton Component
 * Skeleton loader for product carousels (Promotions, New Arrivals, etc.)
 */
const CarouselSkeleton = ({itemCount = 5, cartType = 'normal'}) => {
	return (
		<SkeletonContainer>
			<SkeletonHeader>
				<SkeletonTitle/>
				<SkeletonViewAll/>
			</SkeletonHeader>
			<SkeletonGrid>
				{[...Array(itemCount)].map((_, index) => (
					<ProductSkeleton key={`skeleton-${index}`} cartType={cartType}/>
				))}
			</SkeletonGrid>
		</SkeletonContainer>
	);
};

export default React.memo(CarouselSkeleton);
